import { React, useState, useEffect, useCallback } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Button, CircularProgress, Divider, IconButton, TextField, InputAdornment, Typography, Container } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { acceptUser, getSignUpInfo, rejectUser } from '../../Actions/Auth';
import Fuse from 'fuse.js';
import SearchIcon from "@mui/icons-material/Search";

const columns = [
  { no: 1, id: 'id', label: 'Id', minWidth: 100 },
  { no: 2, id: 'name', label: 'Name', minWidth: 100 },

  {
    no: 3,
    id: 'department',
    label: 'Department',
    minWidth: 100,
    align: 'left',
    format: value => value.toFixed(2),
  },
  {
    no: 4,
    id: 'facultyId',
    label: 'Faculty ID',
    minWidth: 100,
    align: 'left',
    format: value => value.toLocaleString('en-US'),
  },
  {
    no: 5,
    id: 'requestDate',
    label: 'Request Date',
    minWidth: 100,
    align: 'left',
    format: value => value.toFixed(2),
  },
];

function createData(id, name, department, facultyId, requestDate) {
  return { id, name, department, facultyId, requestDate };
}

var originalRows = [];

export default function VerifyRequests() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState(originalRows);
  const [searched, setSearched] = useState('');
  const [tableData, settableData] = useState([]);
  const [query, updateQuery] = useState('');
  const dispatch = useDispatch();
  const Data = useSelector(state => state.signUpData.signUpData);
  const loading = useSelector(state => state.signUpData.isLoading);
  const [forceRerender, setForceRerender] = useState(true);
  const userData = JSON.parse(localStorage.getItem('access_token'));

  const fuse = new Fuse(originalRows, {
    keys: ['id', 'name', 'department', 'facultyId', 'requestDate'],
  });

  const results = fuse.search(query);

  function handleOnSearch({ currentTarget = {} }) {
    const { value } = currentTarget;
    updateQuery(value);
  }
  useEffect(() => {

    const filteredRows = query
      ? results.map((result) => result.item)
      : originalRows

    settableData([...filteredRows])

  }, [query]);


  useEffect(() => {
    dispatch(getSignUpInfo(userData.token));
  }, [dispatch, forceRerender]);

  // console.log('data',Data)

  useEffect(() => {
    originalRows = [];
    if (Data) {
      Data.map(data => originalRows.push(createData(data._id, data.name, data.department, data.empID)));
    }
    originalRows.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.requestDate) - new Date(a.requestDate);
    });
    settableData([...originalRows]);

  }, [Data, forceRerender]);



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function acceptData(row) {
    dispatch(acceptUser({ id: row.id }, userData.token));
    dispatch(getSignUpInfo(userData.token));
    setForceRerender(!forceRerender);
  }

  function rejectData(row) {
    dispatch(rejectUser({ id: row.id }, userData.token));
    dispatch(getSignUpInfo(userData.token));
    setForceRerender(!forceRerender);
  }

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', my: 5 }}>
      <Container sx={{
        display: "flex", flexDirection: ["column", 'row', 'row'], justifyContent: ['center',
          'space-between', "space-between"], px: 0
      }}>
        <Typography
          gutterBottom
          variant="h5"
          component="h2"
          fontWeight="bold"
          fontFamily="Sora"
          display="flex"
          justifyContent="left"
          alignItems="center"
          paddingTop="10px"
          paddingLeft="10px"
          fontSize="25px"
          sx={{ justifyContent: ['left', 'left', 'left'], marginLeft: [1, 0, 0] }}
        >
          All Enquiries
        </Typography>
        <div style={{ padding: 20 }}>
          <TextField placeholder='Search' value={query} onChange={handleOnSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}

          /></div></Container>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress></CircularProgress>
        </div>
      ) : (
        <>
          <Divider />
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map(column =>
                    column.id !== 'id' ? (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        sx={{ fontFamily: 'Sora', color: '#707070' }}
                      >
                        {column.label}
                      </TableCell>
                    ) : (
                      <></>
                    ),
                  )}
                  <TableCell sx={{ fontFamily: 'Sora', color: '#707070' }}>Request</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
                  return (
                    <>
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                        {columns.map(column => {
                          const value = row[column.id];

                          return column.id !== 'id' ? (
                            <>
                              <TableCell key={column.id} align={column.align} sx={{ fontFamily: 'Sora' }}>
                                {column.format && typeof value === 'number' ? column.format(value) : value}
                              </TableCell>
                            </>
                          ) : (
                            <></>
                          );
                        })}
                        <TableCell sx={{ display: 'flex' }}>
                          <Button
                            variant="outlined"
                            sx={{
                              color: '#32CD32', backgroundColor: 'smoke', marginRight: 1, fontFamily: 'Sora', '&:hover': {
                                color: "green"
                              }
                            }}
                            startIcon={<DoneIcon />}
                            onClick={() => acceptData(row)}
                          >
                            Accept
                          </Button>
                          <Button
                            onClick={() => rejectData(row)}
                            sx={{ color: 'red' }}
                            variant="outlined"
                            startIcon={<CloseIcon />}
                          >
                            Decline
                          </Button>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}

      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
